import {
  Box,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import useResponsive from "../../../components/hooks/useResponsive";
import Search from "../../../components/search/Search";
import { COLORS } from "../../../ui/Theme";
import { useSearchParams } from "react-router-dom";
import { Sort } from "@mui/icons-material";
import { HiSortAscending, HiSortDescending } from "react-icons/hi";

const roiPeriodData = [
  { label: "هفتگی", value: "weekly_roi" },
  { label: "ماهانه", value: "monthly_roi" },
  { label: "سه ماهه", value: "quarterly_roi" },
  { label: "شش ماهه", value: "half_yearly_roi" },
  { label: "سالانه", value: "yearly_roi" },
  { label: "سه ساله", value: "three_years_roi" },
];

const RoiIndustriesFilters = () => {
  const { isMd } = useResponsive();
  const [searchParams, setSearchParams] = useSearchParams();

  const params = new URLSearchParams(searchParams);

  const currentRoiPeriod = searchParams.get("roi_period") || "quarterly_roi";
  const currentSortType = searchParams.get("sort") || "ascending";

  const handleRoiPeriod = (e) => {
    const period = e.target.value;

    params.set("roi_period", period);
    setSearchParams(params);
  };

  const handleSort = () => {
    const sortType =
      currentSortType === "ascending" ? "descending" : "ascending";
    params.set("sort", sortType);
    setSearchParams(params);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column-reverse", md: "row" },
        alignItems: "center",
        justifyContentL: "center",
        gap: "15px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          width: { xs: "100%", md: "auto" },
        }}
      >
        {isMd && (
          <Typography
            sx={{ fontSize: "12px", color: COLORS.GRAY, textWrap: "nowrap" }}
          >
            مرتب سازی
          </Typography>
        )}
        <Select
          value={currentRoiPeriod}
          onChange={handleRoiPeriod}
          sx={{
            width: { xs: "100% ", md: "140px" },
          }}
          startAdornment={
            !isMd && (
              <InputAdornment position="start">
                <Sort sx={{ color: COLORS.GRAY }} />
              </InputAdornment>
            )
          }
        >
          {roiPeriodData.map((period) => (
            <MenuItem key={period.value} value={period.value}>
              {period.label}
            </MenuItem>
          ))}
        </Select>

        <button
          style={{
            height: "46px",
            width: "46px",
            color: currentSortType === "ascending" ? COLORS.GREEN : COLORS.RED,
          }}
          onClick={handleSort}
          className="btn"
        >
          {currentSortType === "ascending" ? (
            <HiSortAscending />
          ) : (
            <HiSortDescending />
          )}
        </button>
      </Box>

      <Search placeholder="جستجو : صنعت" width={!isMd ? "" : "250px"} />
    </Box>
  );
};

export default RoiIndustriesFilters;
